import { render, staticRenderFns } from "./policesingto.vue?vue&type=template&id=02fcddbb&scoped=true"
import script from "./policesingto.vue?vue&type=script&lang=js"
export * from "./policesingto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fcddbb",
  null
  
)

export default component.exports